import { Vue } from 'vue-property-decorator';

export const EventBus = new Vue();

export default class EventBusType {
    public static cleanValidators: string = 'cleanValidators';
    public static updatePermissions: string = 'updatePermissions';
}
